import { render } from "./exercise.vue?vue&type=template&id=05b41eb9&scoped=true"
import script from "./exercise.vue?vue&type=script&lang=js"
export * from "./exercise.vue?vue&type=script&lang=js"

import "./exercise.vue?vue&type=style&index=0&id=05b41eb9&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/prod-hys-h5-5.0/hys-h5-5.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b41eb9"]])

export default __exports__